import {Component} from '@angular/core';
import {NgbDropdown, NgbDropdownMenu, NgbDropdownToggle} from "@ng-bootstrap/ng-bootstrap";
import {userDropdownItems} from '@layouts/components/data';
import {RouterLink} from '@angular/router';
import {NgIcon} from '@ng-icons/core';
import {AuthService} from '@core/services/auth.service';

@Component({
  selector: 'app-user-profile-topbar',
  imports: [
    NgbDropdown,
    NgbDropdownMenu,
    NgbDropdownToggle,
    RouterLink,
    NgIcon
  ],
  templateUrl: './user-profile.html'
})
export class    UserProfile {
  menuItems = userDropdownItems;
  displayName = 'Usuário';

  constructor(private readonly authService: AuthService) {
    this.displayName = this.getDisplayName();
  }

  logout(): void {
    void this.authService.logout();
  }

  private getDisplayName(): string {
    const user = this.authService.getCurrentUser();
    if (!user) {
      return 'Usuário';
    }
    if (typeof user === 'string') {
      return user;
    }
    if (typeof user !== 'object') {
      return 'Usuário';
    }
    const data = user as Record<string, unknown>;

    console.log(data);
    
    return data['name'] as string || 'Usuário';
  }
}
